import {TweenLite, gsap} from "gsap";
import Spine = PIXI.spine.Spine;
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {ICart} from "./ICart";

export class TopCarts extends PIXI.Container {
    private carts: ICart[];

    constructor() {
        super();
        this.name = "TopCarts";
        this.init();
    }

    private init() {
        this.position.set(0, 0);
        this.visible = false;
    }

    public reset(): void {
        this.visible = false;
    }

    private emptyCarts():void{
        this.carts.forEach((cart:ICart)=>{
            cart.destroy();
        });
        this.carts = [];
    }

    private addCarts():void{
        ["x1","x1","x1","x1","x1","x1"].forEach((name:string, i:number)=>{
            this.carts.push(new ICart(i, name, this));
        });
    }
    public move(): gsap.core.Timeline {
        this.emptyCarts();
        this.position.set(NolimitApplication.screenBounds.right-100, 0);
        this.addCarts();

        return new gsap.core.Timeline().add(TweenLite.to(this, 0.5, {x: 0}));
    }
}